import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  Paper,
  TableBody,
} from '@mui/material';

import { TableCell as StyledTableCell } from '../../../../components/common/Table';
import Button from '../../../../components/common/Button';
import AssesmentDataTableRow from '../AssesmentDataTableRow';
import {
  downloadCSVFile,
  individualPlotsCropsTableToCSV,
} from '../../CSVFunctions';

export default function IndividualPlotsCropsTable(props) {
  const getCSV = () =>
    downloadCSVFile(individualPlotsCropsTableToCSV(props.dropdownData));
  return (
    <>
      <Grid item xs={12} ref={props.individualPlotsCropsTableRef}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Nazwa uprawy</StyledTableCell>
                <StyledTableCell align="center">
                  Powierzchnia (ha)
                </StyledTableCell>
                <StyledTableCell align="right">
                  Suma dochodów z dopłat (zł)
                </StyledTableCell>
                <StyledTableCell align="center">Szczegóły</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.dropdownData == null
                ? null
                : props.dropdownData.map(function (data) {
                    return (
                      <AssesmentDataTableRow key={data.cropName} data={data} />
                    );
                  })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid item xs={5}>
        <Button
          type="submit"
          variant="contained"
          fullWidth
          onClick={getCSV}
          sx={{ mt: 3, mb: 7 }}
        >
          Eksportuj do CSV
        </Button>
      </Grid>
    </>
  );
}
